import { SAME_DAY, SAME_DAY_NEXT_BUSINESS_DAY_MESSAGE } from '../constants/services'
import { distantDistrictSantiagoTost } from '../constants/states'
import {
  SPECIFIC_STATES_PINFLAG_SERVICES,
  STORES_WITHOUT_PINFLAG_SERVICES,
  THIRD_PARTY_RATES_DATA
} from '../constants/stores'

const filterAtakamaServices = (data) => {
  data.services.sort((a, b) => a.price - b.price)
}

const filterRaindoorServices = (data, conditions) => {
  if (conditions.stateId === 13) data.services = data.services.filter(service => service.serviceType !== SAME_DAY || service.description !== SAME_DAY_NEXT_BUSINESS_DAY_MESSAGE)
}

const filterTostServices = (data, conditions) => {
  const { district } = conditions
  const sameDayService = data.services.find(service => service.serviceType === SAME_DAY)
  if (sameDayService && distantDistrictSantiagoTost.includes(district)) {
    sameDayService.description = sameDayService.description.replace('15', '13')
  }
}

const filterServicesByCompany = {
  'Atakama Outdoor': filterAtakamaServices,
  Raindoor: filterRaindoorServices,
  Tost: filterTostServices
}

export const filterServices = (data, conditions) => {
  const { companyName } = conditions

  filterServicesByCompany[companyName] && filterServicesByCompany[companyName](data, conditions)

  return data
}

export const joinShippingRates = (thirdPartyRates, pinflagServices, companyName, stateId) => {
  const allServices =
    SPECIFIC_STATES_PINFLAG_SERVICES[companyName]?.includes(stateId) ||
    (!STORES_WITHOUT_PINFLAG_SERVICES.includes(companyName) && !SPECIFIC_STATES_PINFLAG_SERVICES[companyName])
      ? pinflagServices
      : { services: [] }

  thirdPartyRates.forEach(rate => {
    if (pinflagServices.services.every(service => service.name !== rate.name)) {
      const { courier, packageDeliveryTime, serviceType, price, name, description } = rate
      const prevDataKey = Object.keys(THIRD_PARTY_RATES_DATA[companyName] || {}).find(rateKey => rate.name.includes(rateKey))

      allServices.services.push({
        courier: courier || '',
        packageDeliveryTime: prevDataKey ? THIRD_PARTY_RATES_DATA[companyName][prevDataKey].packageDeliveryTime : (packageDeliveryTime || ''),
        serviceType,
        price,
        name,
        description: prevDataKey ? THIRD_PARTY_RATES_DATA[companyName][prevDataKey].description : (description || '')
      })
    }
  })
  return allServices
}
